import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import qrcode from "../../../images/qr.png";
import classNames from "classnames";
import styles from "../invoice/Invoice.module.scss";
import { Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllLabReport,
  getOutSourceToLabReport,
  getOutSourceFromLabReport,
} from "../../../store/slices/labReportSlice";
import { waitForImagesToLoad } from "../../components/labReport/waitForImagesToLoad";

const LabReport = () => {
  const dispatch = useDispatch();
  const [showInvoice, setShowInvoice] = useState(false);
  const testInvoiceRefs = useRef([]);
  const profileInvoiceRefs = useRef([]);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const clinic = clinicInfo && clinicInfo?.length > 0 ? clinicInfo[0] : [];
  const { labReport } = useSelector((state) => state.labReport);
  const newLabReport = labReport && labReport.length > 0 ? labReport[0] : null;
  const { token } = useSelector((state) => state.auth);
  const allReportsId = sessionStorage.getItem("allReportsId");
  const outSourceToId = sessionStorage.getItem("outSourceToId");
  const outSourceFromId = sessionStorage.getItem("outSourceFromId");
  const newPatientId = sessionStorage.getItem("patientId");
  const newAppointmentId = sessionStorage.getItem("appointmentId");
  const [pdfHeader, setPdfHeader] = useState(null);
  const [isoLogo, setIsoLogo] = useState(null);

  const formatDateTime = (dateStr, timeStr = "") => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr).toLocaleDateString("en-GB");

    if (timeStr) {
      const [hours, minutes] = timeStr.split(":");
      const h = parseInt(hours);
      const ampm = h >= 12 ? "PM" : "AM";
      const formattedHours = h % 12 || 12;
      return `${date} ${formattedHours}:${minutes} ${ampm}`;
    }

    const fullDate = new Date(dateStr);
    const hasTime = fullDate.getHours() !== 0 || fullDate.getMinutes() !== 0;
    if (hasTime) {
      return `${date} ${fullDate.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })}`;
    }
    return date;
  };

  /**
   * Data Grid Component used in all headers
   */
  const renderLabDataGrid = () => (
    <div className="col-12 mt-2">
      {/* Top Green Bar */}
      <div
        style={{ backgroundColor: "#40be47", height: "1px", width: "100%" }}
      ></div>

      <div
        style={{
          borderLeft: "1px solid #ccc",
          borderRight: "1px solid #ccc",
          padding: "10px 15px",
          fontSize: "14px",
          lineHeight: "1.8",
          color: "#000",
          backgroundColor: "#fff",
        }}
      >
        <div className="row">
          {/* Left Column: Patient Info */}
          <div className="col-6">
            <div className="d-flex">
              <span style={{ width: "110px", fontWeight: "500" }}>Name</span>
              <span>
                :{" "}
                {newLabReport?.patientId?.userId?.name || "Mrs. Dinesh Mishra"}
              </span>
            </div>
            <div className="d-flex">
              <span style={{ width: "110px", fontWeight: "500" }}>
                Age / Sex
              </span>
              <span>
                : {newLabReport?.patientId?.userId?.age?.year || "6"} Yrs /{" "}
                {newLabReport?.patientId?.userId?.gender?.charAt(0) || "M"}
              </span>
            </div>
            <div className="d-flex">
              <span style={{ width: "110px", fontWeight: "500" }}>
                UHID No
              </span>
              <span>: {newLabReport?.patientId?.UHID || "P2024262225"}</span>
            </div>
            <div className="d-flex">
              <span style={{ width: "110px", fontWeight: "500" }}>Client</span>
              <span>: {newLabReport?.clinicId?.clinicName || ""}</span>
            </div>
            <div className="d-flex">
              <span style={{ width: "110px", fontWeight: "500" }}>AppId</span>
              <span>: {newLabReport?.appointmentId || "APP2024262225"}</span>
            </div>
          </div>

          {/* Right Column: Appointment Timing Info */}
          <div className="col-6">
            <div className="d-flex">
              <span style={{ width: "130px", fontWeight: "500" }}>
                Appt Date
              </span>
              <span>
                : {formatDateTime(newLabReport?.appDate) || "25/02/2026"}
              </span>
            </div>
            <div className="d-flex">
              <span style={{ width: "130px", fontWeight: "500" }}>
                Collection Time
              </span>
              <span>
                :{" "}
                {formatDateTime(
                  newLabReport?.collectionDate,
                  newLabReport?.collectionTime,
                ) || "25/02/2026 08:42 AM"}
              </span>
            </div>
            <div className="d-flex">
              <span style={{ width: "130px", fontWeight: "500" }}>
                Receiving Time
              </span>
              <span>
                :{" "}
                {formatDateTime(
                  newLabReport?.receivedDate,
                  newLabReport?.receivedTime,
                ) || "25/02/2026 12:42 PM"}
              </span>
            </div>
            <div className="d-flex">
              <span style={{ width: "130px", fontWeight: "500" }}>
                Reporting Time
              </span>
              <span>
                :{" "}
                {formatDateTime(newLabReport?.updatedAt) ||
                  "25/02/2026 01:43 PM"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Green Bar */}
      <div
        style={{ backgroundColor: "#40be47", height: "1px", width: "100%" }}
      ></div>
    </div>
  );

  const toBase64 = async (url) => {
    if (!url) return null;
    try {
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } catch (e) {
      return null;
    }
  };

  useEffect(() => {
    const loadImages = async () => {
      const headerUrl = clinic?.hospitalInfo?.pdfHeader;
      const isoUrl = clinic?.hospitalInfo?.ISOLogo;
      try {
        const headerBase64 = await toBase64(headerUrl);
        setPdfHeader(headerBase64);
      } catch {
        const fallbackHeader = await toBase64("/images/skLogo.png");
        setPdfHeader(fallbackHeader);
      }
      try {
        const isoBase64 = await toBase64(isoUrl);
        setIsoLogo(isoBase64);
      } catch {
        const fallbackIso = await toBase64("/images/ISOLogo.png");
        setIsoLogo(fallbackIso);
      }
    };
    loadImages();
  }, [clinic]);

  useEffect(() => {
    if (allReportsId) {
      dispatch(
        getAllLabReport({
          clinicId: clinic?.clinicId,
          id: allReportsId,
          patientId: newPatientId,
          appointmentId: newAppointmentId,
          token,
        }),
      );
    } else if (outSourceToId) {
      dispatch(
        getOutSourceToLabReport({
          clinicId: clinic?.clinicId,
          reportId: outSourceToId,
          token,
        }),
      );
    } else if (outSourceFromId) {
      dispatch(
        getOutSourceFromLabReport({
          clinicId: clinic?.clinicId,
          reportId: outSourceFromId,
          token,
        }),
      );
    }
  }, [
    dispatch,
    clinicInfo,
    allReportsId,
    newPatientId,
    newAppointmentId,
    outSourceToId,
    outSourceFromId,
    token,
  ]);

  const splitLabReportsByCategory = (labReport) => {
    if (!labReport) return { testLabReport: [], profileLabReport: [] };
    const tests = labReport.tests || [];
    const profiles = labReport.profiles || [];
    const testLabReportsMap = new Map();
    const profileLabReportsMap = new Map();
    const addToLabReport = (item, type) => {
      const categoryId = item.category?._id;
      if (!categoryId) return;
      const map = type === "test" ? testLabReportsMap : profileLabReportsMap;
      if (!map.has(categoryId)) {
        map.set(categoryId, {
          category: {
            id: categoryId,
            categoryName: item.category?.categoryName,
          },
          tests: [],
          profiles: [],
        });
      }
      if (type === "test") map.get(categoryId).tests.push(item);
      else map.get(categoryId).profiles.push(item);
    };
    tests.forEach((t) => addToLabReport(t, "test"));
    profiles.forEach((p) => addToLabReport(p, "profile"));
    return {
      testLabReport: Array.from(testLabReportsMap.values()),
      profileLabReport: Array.from(profileLabReportsMap.values()),
    };
  };

  const { testLabReport, profileLabReport } = newLabReport
    ? splitLabReportsByCategory(newLabReport)
    : { testLabReport: [], profileLabReport: [] };

  const downloadLabReports = async () => {
    await setShowInvoice(true);
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const allReports = [...testLabReport, ...profileLabReport];
      for (let i = 0; i < allReports.length; i++) {
        const report = allReports[i];
        const isTestReport = report.tests && report.tests.length > 0;
        const inputRef = isTestReport
          ? testInvoiceRefs.current[i]
          : profileInvoiceRefs.current[i - testLabReport.length];
        if (!inputRef) continue;
        await waitForImagesToLoad(inputRef);
        const canvas = await html2canvas(inputRef, {
          scale: 2,
          useCORS: true,
          allowTaint: false,
          width: 950,
          imageTimeout: 15000,
          logging: false,
          letterRendering: true,
          scrollX: 0,
          scrollY: -window.scrollY,
          windowWidth: document.documentElement.offsetWidth,
        });
        const imgData = canvas.toDataURL("image/png");
        const imgWidth = 210;
        const pageHeight = 297;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        if (i > 0) {
          pdf.addPage();
        }
        pdf.addImage(imgData, "PNG", 0, 0, 210, 297);
        let heightLeft = imgHeight - pageHeight;
        let position = -pageHeight;
        while (heightLeft > 0) {
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
          position -= pageHeight;
        }
      }
      pdf.save("LabReports.pdf");
    } catch (err) {
      console.error("Error generating PDF:", err);
    } finally {
      await setShowInvoice(false);
    }
  };

  const handleDownload = async () => {
    await downloadLabReports();
  };

  const invoiceHeaderLeft = () => (
    <div className={classNames("row mb-3", styles.InvoiceHeading)}>
      <div className="col-12 d-flex justify-content-between align-items-start">
        <div className="brand-logo">
          <img
            src={pdfHeader}
            alt="Simplee Kare Health"
            style={{ width: "350px", height: "auto", objectFit: "contain" }}
          />
          <div
            style={{ fontSize: "11px", marginTop: "5px", lineHeight: "1.2" }}
          >
            {clinic?.clinicAddress?.plot || "N2-19"},{" "}
            {clinic?.clinicAddress?.area || "IRC Village, Nayapalli"},{" "}
            {clinic?.clinicAddress?.city?.name || "Bhubaneswar"} -{" "}
            {clinic?.clinicAddress?.pin || "751015"} [cite: 4] <br />
            Call Us: {clinic?.userId?.phone || "+91-9776414444"} |{" "}
            {clinic?.hospitalInfo?.web_address || "www.simpleekare.com"} [cite:
            5]
          </div>
        </div>
        <div className="text-end">
          {clinic?.hospitalInfo?.displayISOlogo && (
            <div className="d-flex flex-column align-items-center">
              <img
                src={isoLogo}
                alt="ISO"
                style={{ width: "65px", height: "auto" }}
              />
              <small style={{ fontSize: "9px", marginTop: "2px" }}>
                150 15189:2007 [cite: 16, 35]
              </small>
            </div>
          )}
        </div>
      </div>
      {renderLabDataGrid()}
    </div>
  );

  const invoiceHeaderRight = () => (
    <div className={classNames("row mb-4", styles.InvoiceHeading)}>
      <div className="col-sm-5 d-flex align-items-center">
        {clinic?.hospitalInfo?.displayISOlogo && (
          <img
            src={isoLogo}
            alt="ISO Logo"
            style={{ width: "60px", height: "60px", objectFit: "contain" }}
          />
        )}
      </div>
      <div className="mt-1 col-sm-7 text-end">
        <div className="brand-logo mb-2">
          <img
            src={pdfHeader}
            alt="Header Logo"
            style={{ width: "350px", height: "70px", objectFit: "contain" }}
          />
        </div>
        <small className="d-block">
          {clinic?.clinicAddress?.city?.name},{" "}
          {clinic?.clinicAddress?.state?.name}
        </small>
        <small className="d-block">
          <strong>Contact:</strong> {clinic?.userId?.phone}
        </small>
      </div>
      {renderLabDataGrid()}
    </div>
  );

  const invoiceHeaderCenter = () => (
    <div className={classNames("row mb-4", styles.InvoiceHeading)}>
      <div className="col-12 text-center">
        <div className="brand-logo mb-2">
          <img
            src={pdfHeader}
            alt="Header Logo"
            style={{ width: "400px", height: "80px", objectFit: "contain" }}
          />
        </div>
        {clinic?.hospitalInfo?.displayISOlogo && (
          <img
            src={isoLogo}
            alt="ISO Logo"
            style={{ width: "60px", marginBottom: "10px" }}
          />
        )}
        <div className="mb-2">
          <small className="d-block">
            {clinic?.clinicAddress?.city?.name},{" "}
            {clinic?.clinicAddress?.state?.name} | <strong>Website:</strong>{" "}
            {clinic?.hospitalInfo?.web_address}
          </small>
        </div>
      </div>
      {renderLabDataGrid()}
    </div>
  );

  const invoiceHeaderFullWidth = () => (
    <div className={classNames("row mb-4", styles.InvoiceHeading)}>
      <div className="mt-1 col-sm-12">
        <div className="brand-logo mb-3 text-center">
          <img
            src={pdfHeader}
            alt="Header Logo"
            style={{ width: "450px", height: "80px", objectFit: "contain" }}
          />
        </div>
      </div>
      {renderLabDataGrid()}
    </div>
  );

  return (
    <Row
      className={showInvoice ? styles.InvoiceWrapper : styles.InvoiceWrapperTwo}
    >
      <div className="col-lg-12">
        {testLabReport?.map((labReport, index) => (
          <div
            key={index}
            className={classNames(styles.InvoiceCard, "card")}
            ref={(el) => (testInvoiceRefs.current[index] = el)}
            style={{
              position: "relative",
              width: "950px",
              minHeight: "1122px",
              height: "1122px",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              margin: "0 auto 30px auto",
              backgroundColor: "white",
              boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            }}
          >
            {clinic?.hospitalInfo?.waterMark && (
              <img
                src={clinic?.hospitalInfo?.waterMark}
                alt="Watermark"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  opacity: 0.08,
                  zIndex: 0,
                  pointerEvents: "none",
                }}
              />
            )}

            <div
              className="card-body d-flex flex-column"
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                zIndex: 1,
                paddingBottom: 0,
                minHeight: 0,
              }}
            >
              {clinic?.hospitalInfo?.headerAlignment === "left" &&
                invoiceHeaderLeft()}
              {clinic?.hospitalInfo?.headerAlignment === "right" &&
                invoiceHeaderRight()}
              {clinic?.hospitalInfo?.headerAlignment === "center" &&
                invoiceHeaderCenter()}
              {clinic?.hospitalInfo?.headerAlignment === "headerFullWidth" &&
                invoiceHeaderFullWidth()}

              <div
                className="table-responsive position-relative"
                style={{ flex: "1 0 auto" }}
              >
                <table className="table">
                  <thead className={styles.thead}>
                    <tr className={styles.tr}>
                      <th className={classNames(styles.th, "center")}>
                        Test Description
                      </th>
                      <th className={classNames(styles.th, "center")}>
                        Value(s)
                      </th>
                      <th className={classNames(styles.th, "right")}>
                        Unit(s)
                      </th>
                      <th className={classNames(styles.th, "center")}>
                        Reference Range
                      </th>
                    </tr>
                  </thead>
                  <tbody className={styles.tbody}>
                    <tr className={styles.tr}>
                      <td colSpan="4" className="fw-bold text-center py-2">
                        {labReport?.category?.categoryName}
                      </td>
                    </tr>
                    {labReport?.tests?.map((test, index) => (
                      <tr className={styles.tr} key={index}>
                        <td
                          className={classNames(styles.td, "left strong")}
                          style={{ fontSize: "12px" }}
                        >
                          {test?.testName}
                        </td>
                        <td className={classNames(styles.td, "left")}>
                          {test?.value}
                        </td>
                        <td className={classNames(styles.td, "right")}>
                          {test?.units}
                        </td>
                        <td className={classNames(styles.td, "center")}>
                          {test?.reference_range_details}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="mt-auto">
                <div className="pb-2 ps-5 pe-0 d-flex justify-content-between position-relative">
                  <div>
                    <b
                      style={{
                        fontSize: "0.8rem",
                        position: "absolute",
                        bottom: "0.6rem",
                      }}
                    >
                      Billed By : SimpleeKare
                    </b>
                  </div>
                  <div style={{ paddingRight: 35, marginTop: 10 }}>
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      {clinic?.hospitalInfo?.authorizedSignature && (
                        <img
                          src={clinic?.hospitalInfo?.authorizedSignature}
                          alt="Signature"
                          style={{
                            width: "150px",
                            height: "70px",
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                      )}
                      <b style={{ fontSize: "0.95rem" }}>Signature</b>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    borderTop: "2px solid #40be47",
                    padding: "1rem 2rem",
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <img
                      src={qrcode}
                      alt="QR Code"
                      style={{ width: "4rem", height: "4rem" }}
                    />
                    <b style={{ fontSize: "0.85rem" }}>
                      * No Extra Amount to be paid apart from Billing Amount.
                    </b>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        <button
          className="btn btn-primary mt-3 text-white"
          onClick={handleDownload}
        >
          Download PDF
        </button>
      </div>
    </Row>
  );
};

export default LabReport;
